import template from './EmailVerificationBannerView.hbs';

import {router} from '../../../js/router';
import {BaseView} from '../../../shared/view/BaseView';

/**
 * @class EmailVerificationBannerView
 * @extends BaseView
 *
 * @property {ResourceLocator} model
 */
export class EmailVerificationBannerView extends BaseView {

    get template () {

        return template;
    }

    get className () {

        return 'df-email-verification';
    }

    get events () {

        return {
            'click .df-ui-panel__header': 'onClickToggle',
            'click .df-email-verification__overlay': 'onClickToggle',
            'click .df-ui-btn': 'onClickButton'
        };
    }

    initialize () {

        Radio.channel('ROUTER').on('ROUTE:FINISH', this.onRouteFinish , this);
        this.model.on('change:user', this.onUpdateUser, this);

        this.isSent = false;
        this.showbanner = false;
    }

    onUpdateUser () {

        let user = this.model.get('user');

        if (user && user.get('uuid') && (user.get('isVerified') === false)) {

            this.showbanner = true;
            this.render();
        }
    }

    onClickToggle () {

        this.$el.toggleClass('df-email-verification--open');
    }

    onClickButton () {

        return $.ajax({
            url: (API_PREFIX + '/users/user-verification'),
            type: 'POST'
        })
        .done(() => {

            this.isSent = true;
            this.render();
        });
    }

    onRouteFinish () {

        let routeEvent = router.getLastEvent();

        this.locale = ((routeEvent && routeEvent.routeNamedArgs) ? routeEvent.routeNamedArgs.languageCode : 'en_de');
        this.render();
    }

    serializeData () {

        return {
            showBanner: this.showbanner,
            isSent: this.isSent
        };
    }

    onDestroy () {

        this.model.off('change:user', this.onUpdateUser, this);
    }
}


// WEBPACK FOOTER //
// ./shared/view/EmailVerificationBannerView/EmailVerificationBannerView.js